import { Inject, Injectable } from '@angular/core';
import { DataLayerService } from '../customer-actions/data-layer.service';
import { CommonModalService } from '../utils/modals/common-modal.service';
import { CommonModalTemplatesEnum } from '../utils/modals/common-modal-templates.enum';

@Injectable()
export class CartClearConfirmationService {
  constructor(
    private dataLayerService: DataLayerService,
    private commonModalService: CommonModalService,
    @Inject('Endpoint') private endpoint: any,
  ) {
  }

  public cartClear() {
    const modalData = {
      templateName: CommonModalTemplatesEnum.CART_CLEAR_CONFIRMATION_MODAL,
      clear: ($event: MouseEvent) => {
        $event.preventDefault();

        this.clearData();
      }
    };

    this.commonModalService.setData(modalData);
  }

  public clearData() {
    this.commonModalService.removeModal(CommonModalTemplatesEnum.CART_CLEAR_CONFIRMATION_MODAL);

    this.endpoint('newCart.removeCart')
      .run()
      .then(() => {
        this.dataLayerService.onClearCart();

        window.location.reload();
      })
      .catch((_error: any) => {
        console.error(_error);
      });
  }

  public justClearData() {
    this.endpoint('newCart.removeCart')
      .run();
  }
}
